// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3SahL","containerItemsCenter":"Skeleton_containerItemsCenter__ZIklh"};